import {connect} from 'react-redux';
import VirtualEventList from 'shared/VirtualEventList.jsx';

import {
  removeVirtualEventFromCart,
  handleOnVirtualEventQuantityChange
} from './actions';

const mapStateToProps = state => ({
  virtualEvents: state.registration.payment.bowlerOwnedVirtualEvents,
  qtyNotEditable: state.registration.base.requireRosterBeforeCheckout
});

const mapDispatchToProps = dispatch => ({
  onRemoveVirtualEvent: id => dispatch(removeVirtualEventFromCart(id)),
  onQuantityChange: data => dispatch(handleOnVirtualEventQuantityChange(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEventList);



// WEBPACK FOOTER //
// ./src/features/registration/checkout/VirtualEventListContainer.jsx